import { Button, Checkbox, Divider, Empty, Form, Radio, Select, Spin } from 'antd'
import { useEffect, useState } from 'react'
export default function SkuDynamic(props) {
  const { formList, onSubmit, loading, currentItem } = props
  const [list, setList] = useState([])
  const [form] = Form.useForm()
  const [btnLoading, setBtnLoading] = useState(false)
  // 初始化
  useEffect(() => {
    formList.map(item => {
      form.setFieldsValue({
        [item.id]: item.optionId || undefined,
      })
    })
    setList(formList)
  }, [formList])

  const onSubmitModal = async () => {
    setBtnLoading(true)
    try {
      await onSubmit(list)
      setBtnLoading(false)
    } catch (error) {
      setBtnLoading(false)
    }
    props.onCancel()
  }

  const onChange = (item, value, index) => {
    let newList: any = [...list]
    if (value) {
      item.skuDynamicOptionVos.map(option => {
        if (option.id === value) {
          item.optionId = option.id
          item.optionName = option.name
        }
      })
    } else {
      newList[index].optionId = undefined
      newList[index].optionName = ''
    }
    newList[index] = item
    setList(newList)
    onSubmit(list, currentItem)
  }

  return (
    <Form
      form={form}
      layout="horizontal"
      style={{ height: '100%' }}
      style={{ marginTop: 20, marginBottom: -20 }}
    >
      {list.map((item: any, index) => {
        return (
          <Form.Item label={item.name} name={item.id} key={item.id}>
            <Select
              onChange={value => onChange(item, value, index)}
              allowClear
              placeholder="请选择"
              style={{ width: '50%' }}
            >
              {item.skuDynamicOptionVos?.map((option, optionIndex) => {
                return <Select.Option value={option.id}>{option.name}</Select.Option>
              })}
            </Select>
          </Form.Item>
        )
      })}
    </Form>
  )
}
